import {DspLegacyStatus, SeatLegacyStatus, Territory} from 'interfaces/generated.types';

export interface ISeatFormValues {
  id: string;
  altId?: number;
  externalSeatId: string;
  name: string;
  journey: string;
  status?: SeatLegacyStatus;
  dspName: string;
  dspId: string;
  dspTerritories: { value: Territory; label: string }[];
  territories: { value: Territory; label: string }[];
}

export const seatStatusValues = [
  {
    value: SeatLegacyStatus.Draft,
    label: 'Draft',
    isDisabled: (value: SeatLegacyStatus) =>
      [SeatLegacyStatus.Active, SeatLegacyStatus.Inactive].includes(value),
  },
  {
    value: SeatLegacyStatus.Active,
    label: 'Active',
    isDisabled: (value: SeatLegacyStatus) => [SeatLegacyStatus.Draft].includes(value),
  },
  {
    value: SeatLegacyStatus.Inactive,
    label: 'Inactive',
    isDisabled: (value: SeatLegacyStatus) => [SeatLegacyStatus.Draft].includes(value),
  },
];

export const getSeatStatusData = (
  values: ISeatFormValues,
  dspStatus: DspLegacyStatus
) => [
  {
    status: SeatLegacyStatus.Draft,
    required: [
      ...(!values.name ? ["Complete 'Name'"] : []),
      ...(!values.dspName ? ['Complete Parent DSP'] : []),
    ],
  },
  {
    status:
      values.status === SeatLegacyStatus.Inactive
        ? SeatLegacyStatus.Inactive
        : SeatLegacyStatus.Active,
    required: [
      ...(!values.name ? ['Waiting for Name'] : []),
      ...(dspStatus !== DspLegacyStatus.Active
        ? ['Waiting for Parent DSP to be in ACTIVE state']
        : []),
      ...(!values.externalSeatId ? ['Waiting for External Seat ID'] : []),
    ],
  },
];

export const seatDetailsFields = ['name', 'externalSeatId'];
